<!-- Container for centering the dialog -->
<div class="centered-dialog">
    <div class="dialog-box">
        <div class="checkmark"></div>
        <h2>Submission Successful!</h2>
        <p>{{successMessage }}</p>
    </div>
</div>